export default __webpack_public_path__ + "static/media/BMMF-Phone02.279397d8.webp";